import { CommonUtility } from '@utility/common';
import { APIPath } from '@utility/constants/api';
import { BaseService } from './base';

class Upload {
  signedUrl(params) {
    const url = `${APIPath.mediaFile}?${CommonUtility.objectToParams(params)}`;
    return BaseService.get(url, true);
  }

  privateSignedUrl(params) {
    const url = `${APIPath.privateMedia}?${CommonUtility.objectToParams(
      params,
    )}`;
    return BaseService.get(url, true);
  }

  poPrivateSignedUrl(params) {
    const url = `${APIPath.poMedia}?${CommonUtility.objectToParams(params)}`;
    return BaseService.get(url);
  }

  privateSignedUrlFlexible(params) {
    const url = `${
      APIPath.privateMediaUploadUrl
    }?${CommonUtility.objectToParams(params)}`;
    return BaseService.get(url);
  }

  media(url, file, contentType) {
    const header = {
      'Content-type': contentType,
    };
    return BaseService.upload(url, file, header);
  }

  getOrderSignedUrl(marketplaceId) {
    return BaseService.get(`${APIPath.importOrders}/${marketplaceId}`);
  }

  getCustomerSignedUrl() {
    return BaseService.get(`${APIPath.importCustomer}`);
  }

  getFulfillmentProviderSignedUrl(marketplaceId, template) {
    const encoded = encodeURIComponent(template);
    return BaseService.get(
      `${APIPath.scmProvider}/${marketplaceId}/inventory/import/${encoded}`,
    );
  }

  getItemsImportAttributesSignedUrl(imperialFlag) {
    return BaseService.get(
      `/items/import/attributes?unit=${imperialFlag ? 'imperial' : 'metric'}`,
    );
  }
}

const UploadService = new Upload();
Object.freeze(UploadService);
export default UploadService;
